import * as React from 'react'
import { FirestoreCollection, withFirestore } from 'react-firestore'

class Actions extends React.Component {
	async doAction(item) {
		const srnkaRef = this.props.firestore
			.collection('srnky')
			.doc(this.props.srnka.id)
		const srnka = (await srnkaRef.get()).data()
		if (srnka.money >= item.cost) {
			await srnkaRef.update({
				food: srnka.food + (item.addFood || 0),
				money: srnka.money - item.cost
			})
		}
	}

	render() {
		return (
			<div>
				<FirestoreCollection
					path="actions"
					render={({ isLoading, data }) =>
						isLoading ? null : (
							<ul>
								{data.map(item => (
									<li key={item.id}>
										{item.title} {item.time} sekund
										<button
											onClick={() => this.doAction(item)}
											disabled={
												item.cost >
												this.props.srnka.money
											}
										>
											Koupit
										</button>
									</li>
								))}
							</ul>
						)
					}
				/>
			</div>
		)
	}
}

export default withFirestore(Actions)



// WEBPACK FOOTER //
// ./src/Actions.js